import React, { useEffect, useState } from 'react';
import { EditorialTemplate, EditorialType } from '../../domain/domain';
import { getEditorialTemplates } from '../../api/editorial';
import SunEditorWrapper from './SunEditorWrapper';

type TextEditorProps = {
    showToolbar: boolean,
    html: string,
    readOnly: boolean,
    editorStyle: any,
    showEditorialTemplates?: boolean,
    showEditorialTypes?: boolean,
    showEditorialButtons?: boolean,
    selectedEditorialType?: EditorialType,
    onChange: (newHtml: string) => void,
}

const TextEditor: React.FC<TextEditorProps> = ({
    showToolbar,
    showEditorialTemplates,
    selectedEditorialType,
    readOnly,
    html,
    onChange,
    editorStyle
}) => {
    const [templates, setTemplates] = useState<EditorialTemplate[] | undefined>(undefined);

    useEffect(() => {
        if (!showEditorialTemplates) {
            setTemplates([]);
            return;
        }
        if (!selectedEditorialType) {
            return;
        }
        getEditorialTemplates(selectedEditorialType).then(response => {
            setTemplates(response.data);
        }).catch(error => {
            console.error(error);
        })
    }, [selectedEditorialType, showEditorialTemplates]);

    if (templates === undefined) {
        return <></>
    }

    return (
        <SunEditorWrapper
            showToolbar={showToolbar}
            readOnly={readOnly}
            html={html}
            onChange={onChange}
            templates={templates}
        />
    )
}

export default TextEditor;
